"use client";
import { MapPin, Phone, MessageCircle, Clock, Building2 } from "lucide-react";
import { trackGeneric } from "@/app/lib/tracking/interactions";

const ContactInfo = () => {
  return (
    <div className="container-minify py-14">
      {/* Top row — 3 cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        {/* Telefon */}
        <a
          href="tel:08504400055"
          onClick={() => trackGeneric("contact_phone", "click")}
          className="group bg-gray-100 rounded-2xl p-7 flex flex-col justify-between min-h-48 hover:bg-gray-200 transition-colors"
        >
          <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center mb-6">
            <Phone className="w-5 h-5 text-gray-700" />
          </div>
          <div>
            <p className="text-xs text-gray-400 uppercase tracking-widest mb-1">
              Çağrı Merkezi
            </p>
            <p className="text-2xl font-bold text-gray-900">0850 440 0055</p>
            <p className="text-xs text-gray-400 mt-2 group-hover:text-gray-600 transition-colors">
              Doğrudan arayın →
            </p>
          </div>
        </a>

        {/* WhatsApp */}
        <a
          href="https://wa.me/905374475666"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackGeneric("contact_whatsapp", "click")}
          className="group bg-gray-100 rounded-2xl p-7 flex flex-col justify-between min-h-48 hover:bg-gray-200 transition-colors"
        >
          <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center mb-6">
            <MessageCircle className="w-5 h-5 text-gray-700" />
          </div>
          <div>
            <p className="text-xs text-gray-400 uppercase tracking-widest mb-1">
              WhatsApp Sipariş
            </p>
            <p className="text-2xl font-bold text-gray-900">+90 537 447 56 66</p>
            <p className="text-xs text-gray-400 mt-2 group-hover:text-gray-600 transition-colors">
              Mesaj gönderin →
            </p>
          </div>
        </a>

        {/* Çalışma Saatleri */}
        <div className="bg-gray-100 rounded-2xl p-7 flex flex-col justify-between min-h-48">
          <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center mb-6">
            <Clock className="w-5 h-5 text-gray-700" />
          </div>
          <div>
            <p className="text-xs text-gray-400 uppercase tracking-widest mb-1">
              Çalışma Saatleri
            </p>
            <p className="text-2xl font-bold text-gray-900">09:00 – 23:59</p>
            <p className="text-xs text-gray-400 mt-2">
              Her gün · Max. 1 saat içinde geri dönüş
            </p>
          </div>
        </div>
      </div>

      {/* Bottom row — adres + şirket bilgileri */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Adres */}
        <div className="bg-gray-100 rounded-2xl p-7">
          <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center mb-5">
            <MapPin className="w-5 h-5 text-gray-700" />
          </div>
          <p className="text-xs text-gray-400 uppercase tracking-widest mb-2">
            Adres
          </p>
          <p className="text-lg font-bold text-gray-900 leading-snug mb-1">
            Ulugazi Mah. İstiklal Cad. No:2
          </p>
          <p className="text-sm text-gray-500">İlkadım — Samsun, Türkiye</p>
        </div>

        {/* Şirket Bilgileri */}
        <div className="bg-gray-100 rounded-2xl p-7">
          <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center mb-5">
            <Building2 className="w-5 h-5 text-gray-700" />
          </div>
          <p className="text-xs text-gray-400 uppercase tracking-widest mb-3">
            Şirket Bilgileri
          </p>
          <p className="text-sm font-bold text-gray-900 leading-snug mb-4">
            MİŞAROĞLU TEKSTİL PAZ. DAĞITIM SAN. VE TİC. LTD. ŞTİ.
          </p>
          <div className="grid grid-cols-3 gap-3 text-xs">
            <div>
              <p className="text-gray-400 mb-0.5">Vergi Dairesi</p>
              <p className="font-semibold text-gray-700">Gaziler VD</p>
            </div>
            <div>
              <p className="text-gray-400 mb-0.5">Vergi No</p>
              <p className="font-semibold text-gray-700">6221822519</p>
            </div>
            <div>
              <p className="text-gray-400 mb-0.5">Mersis No</p>
              <p className="font-semibold text-gray-700">0622182251900001</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;